import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserSaveWrongRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserSaveWrong = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UserSaveWrongRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: UserSaveWrongRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/saveWrong',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['userWrong'] })
      return result
    },
    mutate: (data: UserSaveWrongRequest) => {
      mutation.mutate(
        {
          url: '/user/saveWrong',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userWrong'] })
          },
        }
      )
    },
  }
}
